import { useTranslate } from '@spazious/dollhouse-i18n';
import { Dimensions } from '@spazious/dollhouse-types';
import { Flex, FlexProps, Typography } from '@spazious/dollhouse-uikit';

export interface ModelDimensionInfoProps extends FlexProps {
  dimensions: Dimensions;
}
export const ModelDimensionInfo: React.FC<ModelDimensionInfoProps> = ({
  dimensions,
  ...restProps
}) => {
  const translate = useTranslate();

  const { width, height, length } = dimensions;
  const translatedWidth = translate('Width');
  const translatedHeight = translate('Height');
  const translatedLength = translate('Length');

  return (
    <Flex column {...restProps}>
      <Typography variant="label">
        {translatedLength}: {length}
      </Typography>
      <Typography variant="label">
        {translatedWidth}: {width}
      </Typography>
      <Typography variant="label">
        {translatedHeight}: {height}
      </Typography>
    </Flex>
  );
};
